import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Packages
import { Button, Col, Flex, Row, Typography  } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import ItemsForm from './ItemsForm';
import ItemsTable from './ItemsTable';

// Actions
import { get_all_items } from '../../../redux/actions/itemsActions';

const Items = (props) => {
	const { messageApi } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [update, setUpdate] = useState(false);
	const [itemToUpdate, setItemToUpdate] = useState({});
	const [pageSize, setPageSize] = useState(10);
	const [skip, setSkip] = useState(0);

	useEffect(() => {
		const savedSkip = parseInt(localStorage.getItem('itemsSkip')) || 0;
		setSkip(savedSkip);

		const savedPageSize = parseInt(localStorage.getItem('itemsPageSize')) || 10;
		setPageSize(savedPageSize);

		const filters = { skip: savedSkip, limit: savedPageSize };
		dispatch(get_all_items(filters));
	}, []);

	const handleAdd = () => {
		setIsModalOpen(true);
		setUpdate(false);
		setItemToUpdate({});
	}

	return (
		<div>
			<ItemsForm
				messageApi={messageApi}
				isModalOpen={isModalOpen}
				setIsModalOpen={setIsModalOpen}
				update={update}
				itemToUpdate={itemToUpdate}
				setItemToUpdate={setItemToUpdate}
				filters={{ skip: skip, limit: pageSize }}
			/>

			<Row>
				<Col xs={24} sm={18} md={18} lg={18} xl={18}>
					<Typography.Title>{t('menuItems.items')}</Typography.Title>
				</Col>
				<Col xs={24} sm={6} md={6} lg={6} xl={6}>
					<Flex align='center' justify='flex-end' style={{ height: '100%' }}>
						<Button
							type='primary'
							size='large'
							onClick={handleAdd}
						>
							{t('buttons.create')}
						</Button>
					</Flex>
				</Col>
			</Row>

			<ItemsTable
				messageApi={messageApi}
				setIsModalOpen={setIsModalOpen}
				setUpdate={setUpdate}
				setItemToUpdate={setItemToUpdate}
				pageSize={pageSize}
				setPageSize={setPageSize}
				skip={skip}
				setSkip={setSkip}
			/>
		</div>
	)
}

Items.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default Items;
